import { UploadDocumentJob } from '@domain/types';
import { Selector } from '@reduxjs/toolkit';

import { State } from '@store/reducer';

export const selectUploadDocumentJobs: Selector<State, UploadDocumentJob[]> = (state) =>
  state.uploadDocuments.jobs;
export const selectUploadIntegrationJobs: Selector<State, UploadDocumentJob[]> = (state) =>
  state.integrations.jobs;
